import { Container, Row, Col } from "react-bootstrap";

import navIcon1 from "../assets/img/nav-icon1.svg";

import navIcon3 from "../assets/img/mail.png";
import { Link } from "react-router-dom"; // 🔥 Burası önemli!

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          
          <Col size={12} sm={6}>
            <div className="footer-animation">
              <div className="footer-sun"></div>
              <svg viewBox="0 0 200 200" width="50" height="100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="100" cy="100" r="30" fill="#61dafb" />
                <circle cx="100" cy="100" r="50" fill="none" stroke="#444" strokeDasharray="4 4" strokeWidth="1" />
                <g transform="scale(1.5) translate(-20, -20)">
                  <g>
                    <polygon points="98,50 102,50 100,40" fill="#fff" />
                    <rect x="97" y="50" width="6" height="15" fill="#fff" />
                    <polygon points="97,65 100,70 103,65" fill="#ff3" />
                    <animateTransform
                      attributeName="transform"
                      attributeType="XML"
                      type="rotate"
                      from="0 100 100"
                      to="360 100 100"
                      dur="8s"
                      repeatCount="indefinite"
                    />
                  </g>
                </g>
                <circle cx="30" cy="40" r="1" fill="#fff">
                  <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
                </circle>
                <circle cx="170" cy="60" r="1.5" fill="#fff">
                  <animate attributeName="opacity" values="1;0.2;1" dur="3s" repeatCount="indefinite" />
                </circle>
                <circle cx="50" cy="150" r="1.2" fill="#fff">
                  <animate attributeName="opacity" values="1;0;1" dur="1.5s" repeatCount="indefinite" />
                </circle>
              </svg>
            </div>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
            <a 
  href="https://www.linkedin.com/in/%C3%B6zkan-kizilkan-456054180/" 
  target="_blank" 
  rel="noreferrer"
>
  <img src={navIcon1} alt="LinkedIn" />
</a>
              
              <a href="mailto:kizilkandev@gmail.com"><img src={navIcon3} alt="Email" /></a>
            </div>
            <p>
              © {new Date().getFullYear()} Özkan Kizilkan. All Rights Reserved<br />
              <Link to="/impressum" style={{ marginRight: "10px", color: "#61dafb" }}>
  Legal Disclosure
</Link>
<Link to="/datenschutz" style={{ color: "#61dafb" }}>
  Privacy Policy
</Link>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
